import { Routes } from '@angular/router';
import { AuthModuleGuard } from './pages/auth/auth-module.guard';
import { CheckSecretQuestionsProvidedService } from './pages/auth/services/check-secret-quiestions-provided.service';
import { MainModuleGuard } from './pages/main/main-module.guard';
import { NoAccessModuleGuard } from './pages/no-access/no-access-module.guard';
import { DocumentViewerModuleGuard } from './pages/document-viewer/document-viewer-module.guards';
import { ConfidentialityAgreementModuleGuard } from './pages/ca/confidentiality-agreement-module.guard';
import { AppRouteParts } from './app-routes';
import { AuthenticationIssueModuleGuard } from '@app/pages/authentication-issue/authentication-issue-module.guard';
import { CTMSDashboardPageGuard } from '@app/pages/ctms-dashboard/ctms-dashboard-page.guard';
import { BreadCrumbType } from '@app/ti-components/study-start-up/bread-crumbs/bread-crumbs.models';

const baseRoutes: Routes = [
  {
    path: AppRouteParts.Main,
    loadChildren: () => import('./pages/main/main.module').then((m) => m.MainModule),
    canActivate: [MainModuleGuard],
    canDeactivate: [MainModuleGuard],
    canLoad: [MainModuleGuard],
    resolve: { check: CheckSecretQuestionsProvidedService },
    data: {
      metadata: {
        breadCrumbsType: BreadCrumbType.home,
      },
    },
  },
  {
    path: 'document-viewer/:roomId/:documentId',
    loadChildren: () =>
      import('./pages/document-viewer/document-viewer-page.module').then((m) => m.DocumentViewerPageModule),
    canActivate: [DocumentViewerModuleGuard],
    canDeactivate: [DocumentViewerModuleGuard],
    canLoad: [DocumentViewerModuleGuard],
  },
  {
    path: 'ctms-dashboard/:roomId',
    loadChildren: () =>
      import('./pages/ctms-dashboard/ctms-dashboard-page.module').then((m) => m.CTMSDashboardPageModule),
    canActivate: [CTMSDashboardPageGuard],
    canDeactivate: [CTMSDashboardPageGuard],
    canLoad: [CTMSDashboardPageGuard],
  },
  {
    path: 'no-access',
    loadChildren: () => import('./pages/no-access/no-access-page.module').then((m) => m.NoAccessPageModule),
    canActivate: [NoAccessModuleGuard],
    canDeactivate: [NoAccessModuleGuard],
    canLoad: [NoAccessModuleGuard],
  },
  {
    path: 'authentication-issue',
    loadChildren: () =>
      import('./pages/authentication-issue/authentication-issue-page.module').then(
        (m) => m.AuthenticationIssuePageModule,
      ),
    canActivate: [AuthenticationIssueModuleGuard],
    canDeactivate: [AuthenticationIssueModuleGuard],
    canLoad: [AuthenticationIssueModuleGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [AuthModuleGuard],
    canDeactivate: [AuthModuleGuard],
    canLoad: [AuthModuleGuard],
    canActivateChild: [AuthModuleGuard],
  },
  {
    path: 'esign',
    loadChildren: () => import('./pages/e-sign/e-sign.module').then((m) => m.ESignModule),
  },
  {
    path: 'adobe-sign',
    loadChildren: () => import('./pages/adobe-sign/adobe-sign.module').then((m) => m.AdobeSignModule),
  },
  {
    path: 'ca/:roomId',
    loadChildren: () =>
      import('./pages/ca/confidentiality-agreement-page.module').then((m) => m.ConfidentialityAgreementPageModule),
    canActivate: [ConfidentialityAgreementModuleGuard],
    canDeactivate: [ConfidentialityAgreementModuleGuard],
    canLoad: [ConfidentialityAgreementModuleGuard],
  },
  {
    path: '**',
    redirectTo: AppRouteParts.Main,
  },
];

export const appRoutesProd: Routes = [...baseRoutes];

export const appRoutesDev: Routes = [
  { path: 'examples', loadChildren: () => import('./pages/examples/examples.module').then((m) => m.ExamplesModule) },
  { path: 'test', loadChildren: () => import('./pages/test/test.module').then((m) => m.TestModule) },
  ...baseRoutes,
];
